(function ($) {
	$(document).ready(function () {

		// For each slider in each Feature Slider block.
		$.each($('.feature-slider-block'), function () {
			let slider_block_id = $(this).attr('id');

			$.each($('.feature-slider-container', $(this)), function () {
				let carousel_object = $(this);
				let carousel_id = carousel_object.attr('data-slider-id');
				let slider_group_id = carousel_object.attr('data-slider-group-id');

				// Initialize Slick.
				$(carousel_object).slick({
					dots: false,
					infinite: true,
					speed: 300,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: false,
					variableWidth: true,
					responsive: [
						{
							breakpoint: 1199,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1,
							}
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						},
					]
				});

				// Remove the active state from all slides except the first one.
				if (carousel_id != 1) {
					carousel_object.removeClass('post-active');
				}

				// Hook up the previous button.
				$('.previous-button.slider-' + slider_group_id).click(function () {
					if (carousel_object.hasClass('post-active')) {
						carousel_object.slick('slickPrev');
					}
				});

				// Hook up the next button.
				$('.next-button.slider-' + slider_group_id).click(function () {
					if (carousel_object.hasClass('post-active')) {
						carousel_object.slick('slickNext');
					}
				});
			});

			// Mobile slider selector drop down.
			$('#category-selection-dropdown', $(this)).on('change', function () {
				var target = $(this).val();

				// If the target slider is not active, activate it.
				if (!$('#' + slider_block_id + ' .' + target).hasClass('post-active')) {
					$.each($('#' + slider_block_id + ' .feature-slider-container'), function () {
						$(this).removeClass('post-active');
					});

					$('.' + target).addClass('post-active');
				}
			});

			// Slider selector buttons.
			$('.feature-slider-control-button', $(this)).each(function () {
				$(this).click(function () {
					if (!$(this).hasClass('active')) {
						$('#' + slider_block_id + ' .feature-slider-control-button').each(function () {
							$(this).removeClass('active');
						})
						$(this).addClass('active');

						$('#' + slider_block_id + ' .feature-slider-container').each(function () {
							$(this).removeClass('post-active');
						})
						var target = $(this).attr('data-target');
						$('#' + slider_block_id + ' .' + target).addClass('post-active');
					}
				});
			});
		});

	});
})(jQuery);